import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {CreateAiBase} from "../create-ai-base";
import {
  GlobalEventDispatcherService
} from "../../../../../shared/services/global-event-dispatcher/global-event-dispatcher.service";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../../store";
import {HostingService} from "../../../../../websites/website/hosting/hosting.service";
import {UserService} from "../../../../../user/user.service";
import {GoogleAnalyticsService} from "../../../../../shared/services/google-analytics/google-analytics.service";
import {WebsiteService} from "../../../../../websites/website.service";
import {filter, first, switchMap, takeUntil, tap} from "rxjs/operators";
import {ActivityAction, ActivityStatus} from "../../../../../activities/activity";
import {ActivatedRoute, Router} from "@angular/router";
import {Product} from "../../../../../websites/website/product";
import {
  NotificationDialogComponent
} from "../../../../../shared/components/dialogs/notification-dialog/notification-dialog.component";
import {DialogService} from "../../../../../../ng2-bootstrap-modal/dialog.service";
import {DbActiveModal} from "../../../../../modules/modal/modal-ref";
import {DbModalService} from "../../../../../modules/modal/modal";
import {Website} from "../../../../../websites/website/website";
import {User} from "../../../../../user/user";
import {GenerationFailedComponent} from "./generation-failed/generation-failed.component";
import {Config} from "../../../../../config/config";
import {AiAssistantService} from "../../../../../ai-assistant/service/ai-assistant.service";
import {CookieService} from "ngx-cookie";
import {Utils} from "../../../../../shared/utils/utils";
import {combineLatest} from "rxjs";
import {AuthService} from "../../../../../auth/auth.service";
import {CreateAiAssistantSignUpComponent} from "./create-ai-assistant-sign-up/create-ai-assistant-sign-up.component";
import {Location} from "@angular/common";
import {DbResponse} from "../../../../../shared/interceptors/db-response";
import {ThemeMapper} from "./create-ai-assistant-themes/theme-mapper";
import {Theme} from "./create-ai-assistant-themes/theme";
import {TypeUtils} from "../../../../../shared/utils/type-utils";
import {GlobalEvent} from "../../../../../shared/services/global-event-dispatcher/global-event";
import {UserSubscriptionCategory} from "../../../../../user/user-subscription";
import {TextUtils} from "../../../../../shared/utils/text-utils";
import {UserSubscriptionStatus} from "../../../../../user/user-subscription-status";
import {NotifierComponent} from "../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../shared/components/notifier/notification-type";
import {AiBuilderCommonService} from "../../../../../websites/website/ai-builder/ai-builder-common.service";
import aiSteps from "./ai-steps.json";
import {BuilderV2Component} from "../../../../../builder-v2/builder-v2.component";
import {BuilderHistoryService} from "../../../../../builder-v2/builder-history.service";
import {BuilderStepsEnum} from "../../../../../builder-v2/builder-tour.enum";
import {BehaviorSubject} from "rxjs/internal/BehaviorSubject";
import {BuilderSectionsInteractionService} from "../../../../../builder-v2/builder-sections-interaction.service";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {ReCaptchaV3Service} from "ngx-captcha";
import {BuilderV2Service} from "../../../../../builder-v2/builder-v2.service";
import {showConfetti} from "../../../../../shared/utils/confetti";
import {CreateAiAssistantService} from "./create-ai-assistant.service";
import {CompanyInfo} from "../../../../../store";

type Step =
  'startView'
  | 'chooseWebsiteType'
  | 'storeType'
  | 'companyType'
  | 'template'
  | 'form'
  | 'signUp'
  | 'finalize'
  | 'signUpHubspot';

@Component({
    selector: 'db-create-ai-assistant',
    templateUrl: './create-ai-assistant.component.html',
    styleUrls: ['./create-ai-assistant.component.scss'],
    standalone: false
})
export class CreateAiAssistantComponent extends CreateAiBase implements OnInit, OnDestroy {

  @Input() showThemeNotification = false;
  @Input() override user: User;
  @Input() override website: Website;
  @Input() builderPlugin: Product;
  @Input() elementorPlugin: Product;
  @Input() isFromGenerate: boolean;
  @Input() popupMode: boolean;
  @Input() override isOnboarding: boolean;
  @Input() override websiteId: number;
  @Input() forRecreateFirstTime: boolean;
  @Input() currentOutline: boolean = false;
  @Input() needExceededCheck: boolean = false;
  @Input() showAsDialog?: boolean = false;
  @Input() forceOutlineVersion: boolean = false;
  @Input() choosedStep?: Step;

  public data = [];
  public templatesQuestions = {};
  public current = 0;
  public selectedTemplate = '';
  public selectedTheme = '';
  public fromTemplatesPage: boolean = false;
  public params: Record<string, string | number> = {};
  public step: Step;
  public recreationFinished: Boolean = false;
  public tenWebTheme: Product;
  public themeLoading = false;
  public companyTypes;
  public storeTypes;
  public templates;
  public answersData;
  public themes: Theme[] = [];
  private companyData: any;
  private previewLink = '';
  private _userLoaded: boolean = false;
  public failedGeneration: boolean = false;
  public override fromStartAIPage: boolean;
  public fromInnerAIPage: boolean;
  public imagesLoading: boolean = true;
  public isEcommerce: boolean;
  public loading: boolean;
  public signUpWithHubspot: boolean;
  public isMobile: boolean;
  public currentStep: Step;
  public nextIsTemplate: boolean = false;
  public blogTemplate: boolean = false;
  public email: string = '';
  public encodedCompanyData: any = {};
  public domainInfo: any = {};
  public canGenerateWebsite: boolean = true;
  public aiSteps: string[] = aiSteps;
  selectedCategoryType: 'basic' | 'ecommerce';
  builderStepsEnum = BuilderStepsEnum;
  fromDomains: any;
  domainName: string;
  prefilledAiData: any;
  loadingFirstNext: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  protected readonly TypeUtils = TypeUtils;
  private cookieCheckInterval: ReturnType<typeof setInterval>;

  constructor(
    protected _globalEventDispatcher: GlobalEventDispatcherService,
    protected override _store: Store<fromStore.DbStoreState>,
    protected override _hostingService: HostingService,
    protected override _userService: UserService,
    protected override _googleAnalyticsService: GoogleAnalyticsService,
    private _websiteService: WebsiteService,
    private _aiAssistantService: AiAssistantService,
    private _cookieService: CookieService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _dialogService: DialogService,
    private _activeModal: DbActiveModal,
    private _authService: AuthService,
    private _modalService: DbModalService,
    private _location: Location,
    private _aiBuilderCommonService: AiBuilderCommonService,
    private builderHistoryService: BuilderHistoryService,
    public  builderInteractionsService: BuilderSectionsInteractionService,
    private reCaptchaV3Service: ReCaptchaV3Service,
    private _builderService: BuilderV2Service,
    private _createAiAssistantService: CreateAiAssistantService,
  ) {
    super(_globalEventDispatcher, _store, _hostingService, _userService, _googleAnalyticsService);
  }

  private _removeSavedState() {
    this.builderHistoryService.resetSubjects();
    this.builderInteractionsService.resetSubjects();
    this.builderHistoryService.removeStateFromStorage();
  }

  override ngOnInit() {
    super.ngOnInit();
    this.isMobile = window.innerWidth <= 991;
    this.fromDomains = localStorage.getItem('dbOnboardingDomainName');
    const fromGoogleSignup = window.location.href.indexOf("finalize") > -1 || localStorage.getItem('dbStartAiParams');
    this.fromStartAIPage = window.location.href.indexOf("start-ai-website-building") > -1;
    const companyData = this._route.snapshot.queryParams['prefilledAiData'];
    !this.forceOutlineVersion && (this.forceOutlineVersion = (window.location.href.indexOf("emailCampaign") > -1 && !window.location.href.includes('setup-onboarding')));
    this.fromInnerAIPage = window.location.href.indexOf("ai-builder") > -1;
    this.companyData = this._route.snapshot.queryParams['prefilledAiData'];
    this.email = this._route.snapshot.queryParams['email'];
    this.signUpWithHubspot = false;
    this.currentStep = !!this.signUpWithHubspot && !this.user ? 'signUpHubspot' : 'chooseWebsiteType';
    this._getRecreateOngoingActivity();
    this.showFinalize(fromGoogleSignup);
    if (this.showThemeNotification) {
      this._getTenWebTheme();
    }

    if (localStorage.getItem('showFinalize')) {
      this.step = 'finalize';
    } else {
      if (!!companyData && this.step !== 'finalize') {
        this._createAiAssistantService.hideOnboardingBackButton.next(true);
        this.checkPrefilledData();
      } else {
        this.step = !!fromGoogleSignup ? 'finalize' : (!this.isOnboarding && !this.isFromGenerate ? 'startView' : this.currentStep);
      }
    }

    const queryParamsIndex: number = this._router.url.indexOf('?');
    if (queryParamsIndex !== -1) {
      this._location.replaceState(this._router.url.substring(0, queryParamsIndex));
    }

    this._getActivities();

    if (this.forceOutlineVersion) {
      if (this.user && this.user.signUpFor) {
        const getExperimentalCookie = this._cookieService.get('db-experiment');
        const trialHostedFlow = getExperimentalCookie ? (JSON.parse(getExperimentalCookie) && JSON.parse(getExperimentalCookie).trialFlowVersion ? +JSON.parse(getExperimentalCookie).trialFlowVersion : 0) : 0;
        const productId =  Config.builder2HostedPluginId;
        this.user.signUpFor['FirstChosenOption'] = {answer: 'ai-hosted-section-after-signup', id: ''};
        this.user.signUpFor['LastChosenOption'] = {answer: 'ai-hosted-section-after-signup', id: ''};
        this._authService.updateSignUpFor(this.user.signUpFor, true)
          .pipe(
            first(response => !!response),
          )
          .subscribe(() => {
            this._store.dispatch(new fromStore.LoadUser());
          });
      }
    }

    if (this.signUpWithHubspot) {
      this._setAnswersData();
    }

    if (this.needExceededCheck) {
      this.getGenerationLimit();
    }

    if (!!this.showAsDialog && this.choosedStep) {
      this.step = this.choosedStep;
    }


  }

  checkPrefilledData() {
    // First check if data was already loaded from localStorage
    if (localStorage.getItem('prefilledAiData')) {
      this.companyData = JSON.parse(localStorage.getItem('prefilledAiData'));
      this.setBusinessType(!!this.companyData, false, true);
    }

    this._route.queryParams
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(params => {
        const prefilledData = params['prefilledAiData'];

        if (prefilledData) {
          // Set loading state while processing new data
          this._createAiAssistantService.isDataLoading.next(true);

          this.params = {};
          localStorage.removeItem("prefilledAiData");
          this._removeSavedState();

          const decodedData = decodeURIComponent(prefilledData);
          const prefilledAiDataParsed = JSON.parse(decodedData);
          const initialDesc = prefilledAiDataParsed?.initial_description || this.companyData?.initial_description;
          const industryName = prefilledAiDataParsed?.industry_name || null;
          const websiteType = prefilledAiDataParsed?.website_type || null;

          if (initialDesc) {
            const queryParamsIndex: number = this._router.url.indexOf('?');
            if (queryParamsIndex !== -1) {
              this._location.replaceState(this._router.url.substring(0, queryParamsIndex));
            }
            this._getBusinessDescData(initialDesc, industryName, websiteType);
          } else {
            // If no description but we have prefilled data, update directly
            this._createAiAssistantService.isDataLoading.next(false);
          }
        } else if (!prefilledData && this.companyData) {
          // If query param is removed but we still have companyData, clear it
          this._createAiAssistantService.clearPrefilledData();
          this.companyData = null;
        }
      });
  }

  private _getBusinessDescData(initialDesc, industryName = null, websiteType = null) {
    this._createAiAssistantService.isDataLoading.next(true);

    this.reCaptchaV3Service.execute(Config.googleRecaptcha, 'signup', (token) => {
      // Pass additional parameters to the generateAiBuilderDesc method
      this._builderService.generateAiBuilderDesc(initialDesc, null)
        .pipe(
          filter((response: DbResponse): boolean => !!response),
          first()
        )
        .subscribe((response) => {
          if (response.success) {
            const prefilledAiDataParam = response.data;
            this.sentShortDescData(prefilledAiDataParam);

            if (prefilledAiDataParam) {
              this.companyData = prefilledAiDataParam;
              this._createAiAssistantService.updatePrefilledData(prefilledAiDataParam);
              this.setBusinessType(!!this.companyData, false, true);
            }
          } else {
            this.prefilledAiData = {};
            this._createAiAssistantService.isDataLoading.next(false);
          }
        });
    });
  }

  sentShortDescData(data) {
    const predefinedOrCustom = data.is_predefined ? 'Predefined' : 'Custom';
    const initialDescription = data.initial_description;
    const enhancedDescription = data.site_description;
    const companyType = Utils.capitalize(data?.industry_name);
    const websiteName = Utils.capitalize(data?.business_name);
    const websiteType = data?.website_type;
  }

  public getGenerationLimit() {
    this._store.dispatch(new fromStore.LoadUserSubscription);
    this._store.dispatch(new fromStore.LoadGeneratedWebsiteCount);
    combineLatest(
      this._store.select(fromStore.getUserSubscription),
      this._store.select(fromStore.getRegeneratePermission),
    ).pipe(takeUntil(this._destroyStream$))
      .subscribe(
        ([userSubscription, canRegenerate]) => {
          this.userSubscription = userSubscription;
          this.canGenerateWebsite = canRegenerate;
        }
      );
  }

  private _setAnswersData(): void {
    this.answersData = {};
    this.answersData.Role = {
      "answer": "SMB",
      "id": "eLLnqwOWEyzs"
    };
    this.answersData.WebsiteNumber = {
      "answer": "1-3",
      "id": "EQ6sqoPuMvGg"
    };
    this.answersData.LastChosenOption = {
      "answer": "ai-demo",
      "id": ""
    };
    this.answersData.Action = {
      "answer": "skip",
      "id": ""
    };
  }

  public getBackFromSite(templatesStep: boolean = false): void {
    if (this.companyData && this.current === 0) {
      this.chooseWebsiteType(this.isEcommerce ? 'ecommerce' : 'default', templatesStep);
      this.setBusinessType(!!this.companyData, true);
    }
  }

  public chooseWebsiteType(companyType, templatesStep: boolean = false): void {
    if (!this.showAsDialog) {
      const productId = localStorage.getItem('product_id') || Config.builder2HostedPluginId;

      !this.user && localStorage.setItem('product_id', productId.toString());
      if (this.user && !this.showAsDialog) {
        (this.user.signUpFor['LastChosenOption'] = {answer: (productId === Config.builder2HostedPluginId ? 'ai-hosted-section-after-signup' : 'ai-demo-section-after-signup'), id: ''});
        (this.user.signUpFor['Action'] = {answer: 'skip', id: ''});
        this.updateUserSignupFor();
      }
      if (!this.user) {
        this._removeSavedState();
      }
      this._router.navigate([this.user ? '../builder-v2' : '../v2-ai-website-building'], {
        relativeTo: this._route,
        queryParams: {websiteType: companyType}
      });
      return;
    } else if (!!this.showAsDialog || this.forceOutlineVersion) {
      this.isEcommerce = false;
      this.loadingFirstNext.next(false);
      this.showSectionBasedComponent(companyType);
      return;
    } else if (companyType === 'ecommerce') {
      this.isEcommerce = true;
      this.selectedTemplate = '';
      this.getStoreTypes();
      const productId = Config.demoAiPluginId;

      !this.user && localStorage.setItem('product_id', productId.toString());
    } else {
      const productId = Config.demoAiPluginId;

      !this.user && localStorage.setItem('product_id', productId.toString());
      this.getCompanyTypes(templatesStep);
    }
    if (this.user && !this.showAsDialog) {
      (this.user.signUpFor['LastChosenOption'] = {answer: 'ai-demo-template-after-signup', id: ''});
      (this.user.signUpFor['Action'] = {answer: 'skip', id: ''});
      this.updateUserSignupFor();
    }
  }

  updateUserSignupFor() {
    this._authService.updateSignUpFor(this.user?.signUpFor, true)
      .pipe(
        first(response => !!response),
      )
      .subscribe(() => {
        this._store.dispatch(new fromStore.LoadUser());
      });
  }

  public setDefault(): void {
    this.params = {};
    this.step = (!!this.isOnboarding || !!this.fromInnerAIPage || this.forceOutlineVersion) ? 'chooseWebsiteType' : 'startView';
    /*this.step = (!!this.isOnboarding || !!this.fromInnerAIPage) ? 'companyType' : 'startView';*/
    this.isEcommerce = !this.isEcommerce;
  }

  private _getActivities(): void {
    this._store.select(fromStore.getActivities)
      .pipe(
        filter((loaded: any) => loaded),
        switchMap(() => this._store.select(fromStore.getAiGenerateWebsiteOngoingActivity)),
        takeUntil(this._destroyStream$)
      )
      .subscribe(ongoingActivity => {
        if (!ongoingActivity) {
          return;
        }

        if (ongoingActivity.status === ActivityStatus.RUNNING) {
          this.step = 'finalize';
        }
      });
  }

  public setBusinessType(companyDataExist, dontChangeStep: boolean = false, firstTime: boolean = false): void {
    if (!!companyDataExist) {
      this.encodedCompanyData = this.companyData;
      if (this.encodedCompanyData && this.encodedCompanyData.email && !!this.signUpWithHubspot) {
        this.email = this.encodedCompanyData.email;
      }
      if (!!this.encodedCompanyData.industry_name) {
        if (!!firstTime) {
          // this.isEcommerce = this._route.snapshot.queryParams['website_type'] && this._route.snapshot.queryParams['website_type'] === 'ecommerce';
        }
        this.isEcommerce = this.encodedCompanyData.website_type === 'ecommerce';
        if (!!this.encodedCompanyData.site_description) {
          this.params[this.isEcommerce ? 'store_description' : 'company_description'] = this.encodedCompanyData.site_description;
          this.encodedCompanyData.industry_name && (this.params['business_type'] = this.encodedCompanyData.industry_name);
        }
        this.imagesLoading = false;
        this.setCompanyType(this.encodedCompanyData, !!this.isEcommerce, true, dontChangeStep);
      }
    } else {
      this.step = this.currentStep;
    }
  }

  public showFinalize(fromGoogleSignup): void {
    if (fromGoogleSignup) {
      if (this.user) {
        this.step = 'finalize';
        if (localStorage.getItem('dbStartAiParams')) {
          const dbStartAiParams = localStorage.getItem('dbStartAiParams');
          this.params = JSON.parse(dbStartAiParams);
          this.isEcommerce = this.params['business_category'] === 'store';
        }
        return this.startRecreationProcess();
      } else {
        this.step = 'form';
      }
    }
  }

  private getCompanyTypes(templatesStep: boolean = false): void {
    this._aiAssistantService.getCategories(false, !this.userSubscription || (this.userSubscription && !!this.userSubscription?.plan?.woocommerceService))
      .pipe(
        first(response => !!response),
      )
      .subscribe(response => {
        if (response.success) {
          this.companyTypes = response.data.map(({name, title, keywords, type, group}) => (
            {label: title, value: title, keywords, type, group}
          ));
          this.step !== 'finalize' && this.step !== 'startView' && (this.step = this.selectedTemplate && !this.isEcommerce && !templatesStep && this.current === 0 ? 'template' : 'companyType');
        }
      });
  }

  private getStoreTypes(): void {
    this._aiAssistantService.getCategories(true, !this.userSubscription || (this.userSubscription && !!this.userSubscription?.plan?.woocommerceService))
      .pipe(
        first(response => !!response),
      )
      .subscribe(response => {
        if (response.success) {
          this.storeTypes = response.data.map(({name, title, group, keywords}) => (
            {label: title, value: title, group: group, keywords}
          ));
          this.step = 'storeType';
        }
      });
  }

  protected override startRecreationProcess() {
    // super.startRecreationProcess();
    this.recreateWebsite();
  }

  private updateUserLocalStorage(name, value): void {
    this.userLocalStorage[name] = value;
    this._userService.setToLocal(this.userLocalStorage);
  }

  protected override recreateWebsite(retry?: boolean) {
    super.recreateWebsite();
    this._userLoaded = true;
    !!this.demoUser && this.updateUserLocalStorage('themeId', this.params['theme_id']);
    const regenerate = TypeUtils.isDefined(retry) ? retry : this.failedGeneration;
    const getDomainInfo = localStorage.getItem('dbOnboardingDomainInfo') ? localStorage.getItem('dbOnboardingDomainInfo') : this.domainInfo;
    const paramsData = getDomainInfo ? {...this.params, domain_name: getDomainInfo} : this.params;
    setTimeout(() => {
      this._websiteService.recreateWithAiAssistant(!this.demoUser && !!this.websiteId ? this.websiteId : null, paramsData, regenerate)
        .pipe(
          first(response => !!response)
        )
        .subscribe(response => {
          if (!response.success) {
            return this._showFailedDialog('template');
          }
          this.recreationProcess = true;
          setTimeout(() => {
            this.showHigDemandNotice = true;
          }, 240_000);
        });
    }, 2000);
  }

  public next(data?): void {
    const getExperimentalCookie = this._cookieService.get('db-experiment');
    const imageModel = getExperimentalCookie && !this.popupMode ? JSON.parse(getExperimentalCookie) && JSON.parse(getExperimentalCookie).imageModel && JSON.parse(getExperimentalCookie).imageModel : 'pro';
    const trialHostedFlow = getExperimentalCookie && !this.popupMode ? (JSON.parse(getExperimentalCookie) && JSON.parse(getExperimentalCookie).trialFlowVersion ? +JSON.parse(getExperimentalCookie).trialFlowVersion : 0) : 0;
    this.params = {...this.params, ...data?.formData, image_model: imageModel, trial_hosted_flow: trialHostedFlow};
    data?.domainInfo && (this.domainInfo = data?.domainInfo);
    if (this.current === this.data.length - 1) {
      if (!this.user) {
        this._signUpUser();
      } else {
        this.step = 'finalize';
        return this.startRecreationProcess();
      }
    } else if (this.current >= this.data.length - 1 && !this.user) {
      this._signUpUser();
      return;
    }
    (this.current !== this.data.length - 1) && this.current++;

    // Update back button visibility after form submission
    if (this.companyData) {
      this._createAiAssistantService.hideOnboardingBackButton.next(false);
    }
  }

  private _signUpUser(): void {
    if (this.signUpWithHubspot) {
      this.email && this._signUpViaMagicLink();
    } else {
      this._showSignUpComponent();
    }
  }

  private _signUpViaMagicLink(): void {
    this._authService.signUpViaMagicLink(this.email, Config.basePlanId)
      .pipe(filter((response: DbResponse): boolean => !!response),
        first())
      .subscribe((response) => {
        if (response.success) {

          localStorage.setItem('dbUserRefreshToken', response.data.refresh_token);
          localStorage.setItem('dbUserAccessToken', response.data.token);
          this._store.dispatch(new fromStore.SetWorkspaceIdEntities({
            ownerWorkspaceId: response.data.current_workspace_id,
            currentWorkspaceId: response.data.current_workspace_id,
            currentWorkspaceRoleId: 1,
            globalEventDispatcherService: this._globalEventDispatcher
          }));
          this._globalEventDispatcher.dispatchEvent(GlobalEvent.userLogIn);
          this._store.dispatch(new fromStore.UserLogIn);
          this._store.dispatch(new fromStore.LoadUser);
          this._showFinalizeAndStartRecreation();
        } else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
      });
  }

  private _showSignUpComponent(): void {
    const options = {
      hasCloseBtn: true,
      overflowHidden: false,
    };
    if (!this.isMobile) {
      options['width'] = 900;
      options['height'] = 500;
    }
    const modal = this._modalService.open(CreateAiAssistantSignUpComponent, options);
    modal.componentInstance.title = TextUtils.getText('text_signUpTitleStartAi');
    modal.componentInstance.desc = TextUtils.getText('text_signUpDescStartAi');
    modal.componentInstance.steps = this.aiSteps;
    modal.componentInstance.params = this.params;
    modal.componentInstance.fromEcommerce = this.selectedCategoryType === 'ecommerce';
    modal.closed.subscribe(() => {
      this._showFinalizeAndStartRecreation();
    });
    modal.dismissed.subscribe(() => {
      this._sendGaEvent('pop-up closed');
    });
  }

  private _sendGaEvent(label): void {
    const analyticsData = {
      eventCategory: 'Onboarding',
      eventAction: 'Sign-up form',
      eventLabel: label,
      isMobile: this.isMobile
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCoreWithoutUserData(analyticsData);
  }

  private _showFinalizeAndStartRecreation(): void {
    this.step = 'finalize';
    combineLatest(
      this._store.select(fromStore.getUserLoaded),
      this._store.select(fromStore.getUserLocalStorageLoaded),
    )
      .pipe(
        filter(([userLoaded, storageLoaded]) => userLoaded && storageLoaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getUser),
          this._store.select(fromStore.getUserLocalStorage)
        )),
        filter(([user, userLocalStorage]) => !!user && !!userLocalStorage),
        takeUntil(this._destroyStream$),
        first(),
      )
      .subscribe(([user, userLocalStorage]) => {
        if (this.signUpWithHubspot) {
          this.updateSignUpForData();
          this._userService.setToLocal({createdAfterUM: true});
        }
        if (!this._userLoaded) {
          return this.startRecreationProcess();
        }
      });
  }

  private updateSignUpForData(): void {
    // this._store.dispatch(new fromStore.LoadUser());
    this._authService.updateSignUpFor(this.answersData, true)
      .pipe(
        first(response => !!response, null),
      )
      .subscribe(() => {
        this.userLocalStorage['signUpFor'] = this.answersData;
        this._userService.setToLocal(this.userLocalStorage);
      });
  }

  public back(data): void {
    this.params = {...this.params, ...data};
    if (this.templates.length === 1 && !this.isEcommerce) {
      if (this.current > 0) {
        if (!!localStorage.getItem('prefilledAiData') && this.current === 1) {
          this._createAiAssistantService.hideOnboardingBackButton.next(true);
        }
        this.current--;
      } else {
        this.step = (!this.isEcommerce && this.current === 0) ? 'companyType' : 'chooseWebsiteType';
      }
      return;
    }
    if (this.current === 0) {
      this.step = !!this.isEcommerce ? 'storeType' : 'template';
      return;
    } else {
      if (!!localStorage.getItem('prefilledAiData')) {
        this._createAiAssistantService.hideOnboardingBackButton.next(true);
      }
      this.current--;
    }
  }

  public goToPrevPage(): void {
    if (this.fromInnerAIPage) {
      this.step = (!this.isOnboarding && !this.isFromGenerate ? 'startView' : this.currentStep);
    } else if (this.isOnboarding) {
      this._router.navigate([!this.user ? '/setup-onboarding' : '/setup']);
      if (localStorage.getItem('product_id')) {
        localStorage.removeItem('product_id');
      }
    }
  }

  public showUpgrade(): void {
    if (this.userSubscription && this.userSubscription.isBusiness) {
      this._activeModal.close();
      if (this.userSubscription.plan && !this.userSubscription.plan.additionalDomainCount && ![UserSubscriptionCategory.ENTERPRISE, UserSubscriptionCategory.ENTERPRISE_ULTIMATE, UserSubscriptionCategory.PROFESSIONAl].includes(this.userSubscription.category)) {
        this._showEcommerceFeaturesEnableDialog();
      } else {
        this.openChat(true);
      }
    }
  }

  private _showEcommerceFeaturesEnableDialog(): void {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: 'Enable Ecommerce on Website type selection page',
      eventLabel: 'Upgrade Page'
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
    this._dialogService.addDialog(NotificationDialogComponent, {
      header: TextUtils.getText('text_enableEcommerceFeatures'),
      message: TextUtils.getText('text_enableEcommerceFeaturesDesc'),
      buttonText: TextUtils.getText('text_upgradeToEcommercePlans'),
      buttonColor: 'blue',
      action: 'redirect',
      hasCloseButton: true,
      forEcommerce: true
    })
      .subscribe((confirmed: boolean): void => {
        if (confirmed) {
          if (this.userSubscription
            .status === UserSubscriptionStatus.canceled) {
            this._router.navigate(['/workspace/subscription-plan']);
          } else {
            this._router.navigate(['/upgrade-plan'], {queryParams: {active_tab: 'ecommerce'}});
          }
        }
      });
  }

  private _getRecreateOngoingActivity(): void {
    this._store.select(fromStore.getOngoingActivity)
      .pipe(
        takeUntil(this._destroyStream$),
        tap(activity => activity && activity.meta && activity.meta.page_link && (this.previewLink = activity.meta.page_link)),
        filter(activity => !this.recreationFinished && activity && ((activity.websiteId && (activity.websiteId === this.websiteId || activity.websiteId === Config.demoDomainId)) || !activity.websiteId)
          && (activity.action === ActivityAction.INSTALL || activity.action === ActivityAction.INSTALL_HOSTED_TEMPLATE
            || (activity.status === ActivityStatus.FAILED && activity.action === ActivityAction.AI_GENERATE_WEBSITE))
          && (activity.status === ActivityStatus.DONE || activity.status === ActivityStatus.FAILED))
      )
      .subscribe(activity => {
        this.recreationProcess = false;

        if (this.isOnboarding) {
          this.userLocalStorage['onboardingFinished'] = true;
          this.userLocalStorage['onboardingPassed' + this.websiteId] = true;
          this.userLocalStorage['setupAiRecreation'] = false;
        } else {
          this.userLocalStorage['seenNewAiFlow' + this.websiteId] = true;
        }
        this._userService.setToLocal(this.userLocalStorage)
          .pipe(
            first(response => !!response),
          )
          .subscribe(response => {
            if (response.success) {
              this._store.dispatch(new fromStore.LoadUser());
              this._store.dispatch(new fromStore.LoadUserLocalStorage());
            }
          });

        if (activity.status === ActivityStatus.DONE) {
          this._destroyStream$.next(true);
          this._destroyStream$.complete();

          if (!this.isOnboarding) {
            return;
          }
          this._modalService.dismissAll();
          this._dialogService.hasOpenedDialog() && this._dialogService.removeAll();
          this.recreationFinished = true;
          /*//check this part
          if (!!this._userLoaded && !!this.fromStartAIPage) {
            setTimeout(() => {
              this._store.dispatch(new fromStore.LoadUser());
              this._store.dispatch(new fromStore.LoadUserSubscription);
              this._store.dispatch(new fromStore.LoadWebsites());
            }, 3000);
          }*/
          setTimeout(() => {
            localStorage.removeItem("dbStartAiParams");
            this.showSuccessDialog();
          }, 1000);
          this._store.dispatch(new fromStore.LoadUserSubscription);
        }
        if (activity.status === ActivityStatus.FAILED) {
          localStorage.removeItem('prefilledAiData');
          this._modalService.dismissAll();
          this._dialogService.hasOpenedDialog() && this._dialogService.removeAll();
          this._showFailedDialog('outline');
        }
      });
  }

  private _getTenWebTheme(): void {
    this._store.select(fromStore.getWebsiteTenWebTheme(this.websiteId))
      .pipe(
        takeUntil(this._destroyStream$)
      )
      .subscribe(theme => this.tenWebTheme = theme);
  }

  public activateTenWebTheme(): void {
    if (!this.tenWebTheme) return;
    this._getWebsite(this.websiteId).then(() => {
      this.themeLoading = true;
      const network = this.website.domain_hash ? 1 : 0;
      this._store.dispatch(new fromStore.InitWebsiteProductAction({
        website: this.website,
        products: [this.tenWebTheme],
        action: ActivityAction.INSTALL_ACTIVATE,
        network: network
      }));
      this.getTenWebThemeActivity();
    });
  }

  private getTenWebThemeActivity(): void {
    this._store.select(fromStore.getOngoingActivity)
      .pipe(
        first(activity => activity && activity.websiteId === this.website.id
          && (activity.status === ActivityStatus.DONE || activity.status === ActivityStatus.FAILED)
          && activity.meta && activity.meta.product_data && activity.meta.product_data.type
          && activity.meta.product_data.type === 'theme'
        )
      )
      .subscribe(() => {
        this.themeLoading = false;
      });
  }

  showSuccessDialog() {
    const dbTesting = !!this._cookieService.get('db-testing');
    const preview = `${this.previewLink}?from=onboarding&domain_id=${Config.demoDomainId}&client_id=${this.user?.id}&client_email=${this.user?.email}&first_time` + (dbTesting ? `&db-testing` : ``);
    if (!!this.isOnboarding) {
      this._globalEventDispatcher.dispatchEvent(GlobalEvent.showDemoPreviewIframe, {
        showIframe: true,
        iframeUrl: preview
      });
      this._store.dispatch(new fromStore.LoadWebsites());

      setTimeout(() => {
        if (!!this.isMobile) {
          this._router.navigateByUrl('/single-page-demo');
        } else {
          this._router.navigateByUrl('/websites');
          showConfetti();
        }
        localStorage.removeItem('prefilledAiData');
        this.openCongratsPopup(preview);
      }, 1000);
    } else {
      showConfetti();
      this.openCongratsPopup(preview);
    }
  }

  private openCongratsPopup(preview): void {
    localStorage.removeItem('showFinalize');
    this._dialogService.addDialog(NotificationDialogComponent, {
      header: TextUtils.getText('text_congratsFromManager'),
      message: TextUtils.getText('text_websiteSuccessfullyCreatedWithAI'),
      buttonText: TextUtils.getText('text_previewAndEdit'),
      buttonColor: 'black',
      hasGradientBorder: true,
      hasAdminLink: false,
      action: 'preview',
      hasCloseButton: false
    })
      .subscribe((confirmed: string): void => {
        if (confirmed === 'preview') {
          if (!this.isOnboarding) {
            window.open(preview, "_blank", "noopener");
          }
        }
      });
  }

  private _showFailedDialog(mode): void {
    localStorage.removeItem('showFinalize');
    this.failedGeneration = true;
    const modal = this._modalService.open(GenerationFailedComponent, {width: 500, hasCloseBtn: true});
    modal.closed.subscribe(() => {
      mode !== 'outline' && this.recreateWebsite(true);
    });
    modal.dismissed.subscribe(res => {
     if (mode !== 'outline') {
       if (res === 'chat') {
         this._router.navigate(['/websites']);
         this.openChat();
       } else {
         this.recreationProcess = false;
         this.globalEventDispatcher.dispatchEvent(GlobalEvent.hideOnboardingBackButton, 0);
         this.step = this.currentStep;
       }
      }
    });
  }

  private openChat(fromEcommerce?: boolean) {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: 'Enable Ecommerce on Website type selection page',
      eventLabel: 'Open Chat'
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
    if (fromEcommerce && (localStorage.getItem('dbChatMessageSent') === null)) {
      window['Smooch']?.createConversation({
        messages: [
          {
            text: 'I want to enable ecommerce features',
            type: 'text',
            metadata: {
              ecommerce: true,
            }
          }
        ]
      }).then(() => {
        window['Smooch']?.open();
      });
      this._store.dispatch(new fromStore.ToggleChatOverlay(false));
      localStorage.setItem('dbChatMessageSent', '1');
    } else {
      window['Smooch']?.open();
      this._store.dispatch(new fromStore.ToggleChatOverlay(false));
    }
  }

  public setCompanyType(businessData: {
    type: string;
    group: string
  }, isEcommerce: boolean = false, fromLandingPage: boolean = false, dontChangeStep: boolean = false): void {
    this.current = 0;
    this.params['template_id'] = '';
    this.params = {
      ...this.params,
      business_type: fromLandingPage ? businessData['industry_name'] : businessData['type'],
      business_category: fromLandingPage ? businessData['website_type'] : businessData['group']
    };
    this.isEcommerce = isEcommerce;
    this.builderInteractionsService.businessCategory.next(fromLandingPage ? businessData['website_type'] : businessData['group']);
    this._aiAssistantService.getTemplateQuestions(fromLandingPage ? businessData['industry_name'] : businessData['type'], isEcommerce, fromLandingPage)
      .pipe(
        first(response => !!response)
      )
      .subscribe(response => {
        if (response.success) {
          this.templates = response.data && response.data.templates ? Object.keys(response.data.templates).map(key => response.data.templates[key]) : [];
          this.themes = (response.data.themes).map(theme => ThemeMapper.map(theme));
          if (!!this.encodedCompanyData.template_id) {
            this.themes && this.themes[0] && this.themes[0].id && this.setTheme(this.themes[0].id, false);
            this.setTemplate(this.encodedCompanyData.template_id, true);
          } else if (this.templates.length === 1) {
            this.themes && this.themes[0] && this.themes[0].id && this.setTheme(this.themes[0].id, dontChangeStep);
            if (!dontChangeStep) {
              this.step === 'form';
            }
          } else {
            if (!isEcommerce) {
              /* change templates ordering */
              this.templates = Utils.sort(
                this.templates, (a, b): number => {
                  const l = a.order_in_view, r = b.order_in_view;
                  return l > r ? 1 : -1;
                });
            }
            if (!dontChangeStep) {
              this.step = 'template';
            }
          }

          const allData = response.data && response.data.questions ? Utils.sortObjectByKey(response.data.questions, "name_desc") : {};
          this.data = Object.keys(allData).length ? Object.keys(allData).map(key => allData[key]) : [];


          if (response.data && response.data.templates && Object.keys(response.data.templates).length > 1) {
            this.templatesQuestions = response.data.templates;
            if (!!this.encodedCompanyData.template_id) {
              this._setNewFormData(this.templatesQuestions, this.encodedCompanyData.template_id);
            }
          } else if (response.data && response.data.templates && Object.keys(response.data.templates).length === 1) {
            const firstKeyOfObject = Object.keys(response.data.templates)[0];
            this._setNewFormData(response.data.templates, firstKeyOfObject);
          }
        }
      });
  }

  private _setNewFormData(data, key): void {
    const questions = data[key].questions;
    this.templatesQuestions = data;
    if (questions.hasOwnProperty("lang_name_desc")) {
      const questions = this.templatesQuestions[key].questions;
      const allData = questions ? Utils.sortObjectByKey(questions, "lang_name_desc") : {};
      this.data = Object.keys(allData).length ? Object.keys(allData).map(key => allData[key]) : [];
    }
  }

  public setTemplate(template: string, fromLanding?: boolean): void {
    if (TypeUtils.isDefined(this.templatesQuestions) && Object.keys(this.templatesQuestions).length > 1) {
      const questions = this.templatesQuestions[template].questions;
      const allData = questions ? Utils.sortObjectByKey(questions, "name_desc") : {};
      this.data = Object.keys(allData).length ? Object.keys(allData).map(key => allData[key]) : [];
    }

    if (this.companyData) {
      const encodedCompanyData = JSON.parse(decodeURIComponent(this.companyData));
      this.params = {
        ...encodedCompanyData, ...this.params,
        theme_id: this.params['theme_id'],
        template_id: template
      };
    } else {
      this.params = {
        ...this.params,
        business_type: this.params['business_type'],
        theme_id: this.params['theme_id'],
        template_id: template
      };
    }
    this.step = 'form';
    this.companyData = null;
  }

  public setTheme(theme: string, dontChangeStep: boolean = false): void {
    if (this.companyData) {
      const encodedCompanyData = this.companyData;
      this.params = {
        ...encodedCompanyData, ...this.params,
        theme_id: theme
      };
    } else {
      this.params = {...this.params, business_type: this.params['business_type'], theme_id: theme};
    }
    if (!dontChangeStep) {
      if (this.templates.length === 1) {
        this.params['template_id'] = this.templates[0].template_id;
        this.step = 'form';
      } else {
        this.step = 'template';
      }
    }
  }

  public onStart() {
    if (!this.canGenerateWebsite && this.needExceededCheck) {
      this._aiBuilderCommonService.handleGenerationExceeded(this.userSubscription);
      return;
    }

    /*<db-create-ai-assistant [websiteId]="websiteId" [isOnboarding]="false"
    [needExceededCheck]="true" [forRecreateFirstTime]='forRecreateFirstTime'
     [showThemeNotification]="true" [user]="user"
        [website]="website" [builderPlugin]="builderPlugin"
        [elementorPlugin]="elementorPlugin"></db-create-ai-assistant>*/
    const modal = this._modalService.open(CreateAiAssistantComponent, {fullHeight: true});
    modal.componentInstance.websiteId = this.websiteId;
    modal.componentInstance.isOnboarding = false;
    modal.componentInstance.needExceededCheck = true;
    modal.componentInstance.forRecreateFirstTime = true;
    modal.componentInstance.showThemeNotification = true;
    modal.componentInstance.user = this.user;
    modal.componentInstance.website = this.website;
    modal.componentInstance.builderPlugin = this.builderPlugin;
    modal.componentInstance.elementorPlugin = this.elementorPlugin;
    modal.componentInstance.showAsDialog = true;
    modal.componentInstance.popupMode = true;
    modal.componentInstance.choosedStep = 'chooseWebsiteType';
    this.current = 0;
  }

  public showSectionBasedComponent(type): void {
    const builderV2 = this._modalService.open(BuilderV2Component, {
      fullHeight: true,
      hasOutsideCloseBtn: true,
    });
    builderV2.componentInstance.companyType = type;
    builderV2.componentInstance.website = this.website;
    builderV2.componentInstance.domainId = this.websiteId;
    builderV2.componentInstance.popupMode = true;
    builderV2.componentInstance.emailCampaign = this.forceOutlineVersion;
    builderV2.componentInstance.currentOutline = !!this.currentOutline;
    builderV2.componentInstance.demoUser = this.demoUser;
    builderV2.componentInstance.user = this.user;
    builderV2.dismissed.subscribe(() => {
      this._activeModal.close();
    });
  }

  ngOnDestroy() {
    if (this.cookieCheckInterval) {
      clearInterval(this.cookieCheckInterval);
    }
    this.loadingFirstNext.next(false);
    this._destroyStream$.next(true);
    this._destroyStream$.complete();

    // Use service to clear prefilled data
    if (!this.isMobile) {
      this._createAiAssistantService.clearPrefilledData();
    }
  }
  headerBack() {
    this._activeModal.close();
  }
}
